import { all, takeLeading } from 'redux-saga/effects';

import { Types as pedidosTypes } from '../ducks/pedidos';
import { searchPedidos } from './pedidos';

import { Types as produtosTypes } from '../ducks/produtos';
import { searchProdutos } from './produtos';

// O * identifica um generator assim como async, e o yield é um await
export default function* rootSaga() {
    return yield all([
        takeLeading(pedidosTypes.GET_REQUEST, searchPedidos),
        takeLeading(produtosTypes.GET_REQUEST, searchProdutos)
    ]);
}
